import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

import type { TabRoute } from "@/@types/tab-navigation";

interface TabBarProps {
  tabs: TabRoute[];
  activePath: string | undefined;
  onSelect: (path: string) => void;
}

export const TabBar = ({ tabs, activePath, onSelect }: TabBarProps): JSX.Element => (
  <Tabs value={activePath ?? ""} onValueChange={onSelect} className="w-full">
    <TabsList className="flex h-auto w-full flex-wrap justify-start gap-1 rounded-lg border bg-white p-1">
      {tabs.map((tab: TabRoute) => (
        <TabsTrigger
          key={tab.key}
          value={tab.path}
          onClick={(): void => onSelect(tab.path)}
          className="rounded-md transition-all data-[state=active]:bg-[#2E0D1E] data-[state=active]:text-white data-[state=active]:shadow-sm"
        >
          {tab.label}
        </TabsTrigger>
      ))}
    </TabsList>
  </Tabs>
);
